import React, { Component, PropTypes } from 'react';
import { Col, FormGroup } from 'react-bootstrap';
import Make from '../../quotationPVComponent/make/Make';
import Model from '../../quotationPVComponent/model/Model';
import CubicCapacity from '../../cubicCapacity/CubicCapacity';
import SeatingCapacity from '../../quotationPVComponent/seatingCapacity/SeatingCapacity';
import YearOfManufacture from '../../quotationPVComponent/yearOfManufacture/YearOfManufacture';
import VehicleRegNo from '../../vehicleRegNo/VehicleRegNo';

class ParticularOfVehicle extends Component {

  constructor(props) {
    super(props);
    this.state = {
      option: []
    }
  }

  render() {
    return (
      <div className="ebaoUtil__Top-Bottom-Line">
        <h3 className="ebaoUtil__HeaderThree">Particular of Vehicle</h3>
          <FormGroup controlId="modelMake">
            <Col sm={6}>
              <Make
                handleChangeMake={this.props.handleChangeParticularOfVehicle}
                calculation={this.props.calculation}
                make={this.props.particularOfVehicle.make}
              />
            </Col>
            <Col sm={6}>
              <Model
                option={this.props.option}
                handleChangeModel={this.props.handleChangeParticularOfVehicle}
                calculation={this.props.calculation}
                model={this.props.particularOfVehicle.model}
              />
            </Col>
          </FormGroup>
          <FormGroup controlId="cubicCapSeatingCap">
            <Col sm={6}>
              <CubicCapacity
                cubicCap={this.props.particularOfVehicle.cubicCap}
                handleChangeCubicCap={this.props.handleChangeParticularOfVehicle}
              />
            </Col>
            <Col sm={6}>
              <SeatingCapacity
                seatingCap={this.props.particularOfVehicle.seatingCap}
                handleChangeSeatingCap={this.props.handleChangeParticularOfVehicle}
              />
            </Col>
          </FormGroup>
          <FormGroup controlId="yearOfManufactureVehicleRegNo">
            <Col sm={6}>
              <YearOfManufacture
                yearOfManufacture={this.props.particularOfVehicle.yearOfManufacture}
                handleChangeYearOfManufacture={this.props.handleChangeParticularOfVehicle}
              />
            </Col>
            <Col sm={6}>
              <VehicleRegNo
                vehicleRegNo={this.props.particularOfVehicle.vehicleRegNo}
                handleChangeVehicleRegNo={this.props.handleChangeParticularOfVehicle}
                validation={this.props.validation}
              />
            </Col>
          </FormGroup>
      </div>
    )
  }
}

ParticularOfVehicle.propTypes = {
  particularOfVehicle: PropTypes.object,
  handleChangeParticularOfVehicle: PropTypes.func,
  option: PropTypes.array,
  calculation: PropTypes.func,
  validation: PropTypes.func
};

export default ParticularOfVehicle;



// WEBPACK FOOTER //
// ./src/app/components/quotationPVComponent/particularOfVehicle/ParticularOfVehicle.js